<script setup lang="ts">
const props = defineProps({
   position: {
      type: Object,
      default: () => ({}),
   },
});
</script>

<template>
   <template v-for="description in position.descriptions">
      <div v-if="description.position_description_type.key">
         <h3>{{ description.position_description_type.name }}</h3>
         <div v-html="description.description"></div>
      </div>
   </template>

   <!-- Educations -->
   <div v-if="position?.profile?.educations?.length > 0">
      <h3>{{ $tb('public.candidates.educations', 2) }}</h3>
      <ul>
         <li v-for="profileEducation in position.profile?.educations" :key="profileEducation.id" class="position-body__desired-function">
            {{ profileEducation?.degree?.name }}
         </li>
      </ul>
   </div>

   <!-- Languages -->
   <div v-if="position?.profile?.profile_languages?.length > 0">
      <h3>
         {{
            $te('public.candidates.language-knowledge')
               ? $tb('public.candidates.language-knowledge')
               : $tb('public.candidates.language-knowlegde')
         }}
      </h3>
      <ul>
         <li
            v-for="profileLanguage in position.profile?.profile_languages"
            :key="profileLanguage.id"
            class="position-body__desired-function"
         >
            {{ profileLanguage?.language.name }}
         </li>
      </ul>
   </div>

   <!-- Certificates -->
   <div v-if="position?.profile?.profile_certificates?.length > 0">
      <h3>{{ $tb('public.candidates.certificates') }}</h3>
      <ul>
         <li
            v-for="profileCertificate in position.profile?.profile_certificates"
            :key="profileCertificate.certificate.id"
            class="candidate-body__certificate"
         >
            {{ profileCertificate.certificate?.name }}
         </li>
      </ul>
   </div>

   <!-- Competences -->
   <div v-if="position?.profile?.profile_competences?.length > 0">
      <h3>{{ $tb('public.candidates.competences', 1) }}</h3>
      <ul>
         <li
            v-for="profileCompetence in position.profile?.profile_competences"
            :key="profileCompetence.competence.id"
            class="position-body__desired-function"
         >
            {{ profileCompetence.competence.name }}
         </li>
      </ul>
   </div>

   <!-- Work Schedules -->
   <div v-if="position?.profile?.profile_work_schedules?.length > 0">
      <h3>{{ $tb('public.candidates.work-schedules') }}</h3>
      <ul>
         <li
            v-for="profileWorkSchedule in position?.profile?.profile_work_schedules"
            :key="profileWorkSchedule.id"
            class="candidate-body__work-schedule"
         >
            {{ profileWorkSchedule.work_schedule.name }}
            <span v-if="position.hours_per_week">({{ position.hours_per_week }})</span>
         </li>
      </ul>
   </div>

   <!-- Drivers Licenses -->
   <div v-if="position?.profile?.profile_drivers_licenses?.length > 0">
      <h3>{{ $tb('public.candidates.drivers-license') }}</h3>
      <ul>
         <li
            v-for="profileDriversLicense in position.profile?.profile_drivers_licenses"
            :key="profileDriversLicense.id"
            class="candidate-body__drivers-license"
         >
            {{ profileDriversLicense.drivers_license?.name }}
         </li>
      </ul>
   </div>

   <!-- Transport -->
   <div v-if="position?.profile?.profile_transport_methods?.length > 0">
      <h3>{{ $tb('public.candidates.transport-methods') }}</h3>
      <ul>
         <li
            v-for="profileTransportMethod in position.profile?.profile_transport_methods"
            :key="profileTransportMethod.id"
            class="candidate-body__work-schedule"
         >
            {{ profileTransportMethod.transport_method.name }}
         </li>
      </ul>
   </div>
</template>
